import React, { useCallback } from 'react';

import { IconButton } from '../../buttons';
import { Styled } from './styled';

export const IconButtonMenuIcons = React.memo(({
  id,
  Icon,
  isSelected,
  onClick,
  defaultColor,
}) => {
  const onIconButtonClick = useCallback(() => onClick(id), [id]);

  return (
    <Styled.IconContainer
      isSelected={isSelected}
      onClick={onIconButtonClick}
    >
      <IconButton
        Icon={Icon}
        height={40}
        defaultColor={defaultColor}
      />
    </Styled.IconContainer>
    )
  }
)
